<template>
  <div>
    <div class="flex mx-auto flex-row justify-between md:block hidden text-xs">
      <span class="cursor-pointer" :class="textClass" v-scroll-to="'#about'"
        >About</span
      >
      <span class="text-gray-600">|</span>
      <span
        class="cursor-pointer"
        :class="textClass"
        v-scroll-to="'#experience'"
        >Experience</span
      >
      <span class="text-gray-600">|</span>
      <span class="cursor-pointer" :class="textClass" v-scroll-to="'#projects'"
        >Projects</span
      >
      <span class="text-gray-600">|</span>
      <span class="cursor-pointer" :class="textClass" v-scroll-to="'#contact'"
        >Contact</span
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    primary: {
      type: String,
      default: "light",
    },
    size: {
      type: String,
      default: "lg",
    },
  },
  computed: {
    textClass() {
      return this.primary == "dark"
        ? "text-gray-800 hoverTextDark"
        : "text-yellow-400 hoverText";
    },
  },
};
</script>
<style scoped lang="scss">
.hoverText {
  transition: all ease-in-out 0.3s;
  font-family: monospace;
  font-size: 15px;
  margin-left: 10px;
  margin-right: 10px;
  letter-spacing: 1.2px;
  padding-bottom: 5px;
  &:hover {
    font-size: 17px;
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    letter-spacing: 2px;
    border-bottom: 1px solid yellow;
  }
}

.hoverTextDark {
  transition: all ease-in-out 0.3s;
  font-family: monospace;
  font-size: 14px;
  margin-left: 7px;
  margin-right: 7px;
  letter-spacing: 1px;
  padding-bottom: 5px;
  &:hover {
    font-size: 16px;
    font-weight: bold;
    margin-left: 11px;
    margin-right: 11px;
    letter-spacing: 1.5px;
    border-bottom: 1px solid black;
  }
}
</style>